import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    FaIconLibrary,
    FontAwesomeModule,
} from '@fortawesome/angular-fontawesome';
import {
    faCaretDown,
    faCaretUp,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircleExclamation,
    faCircleUser,
    faGlobe,
    faPen,
    faPlus,
    faSearch,
    faSync,
    faTimes,
    faTrash,
    faTrashCan,
} from '@fortawesome/free-solid-svg-icons';
import { ImageViewerComponent } from './image.viewer.component';

@NgModule({
  imports: [CommonModule, FontAwesomeModule, ImageViewerComponent],
  exports: [ImageViewerComponent],
  providers: [ImageViewerComponent],
})
export class VizImageViewerModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(
      faTimes,
      faChevronDown,
      faChevronUp,
      faChevronRight,
      faChevronLeft,
      faCaretDown,
      faCaretUp,
      faSync,
      faCircleUser,
      faSearch,
      faPlus,
      faTrash,
      faTrashCan,
      faPen,
      faGlobe,
      faCircleExclamation,
    );
  }
}
